<template>
  <div>
    <MasterHeader
        v-bind:classHeader="'registration'"
        v-bind:classGrid="'wp1200'"
        v-bind:showToastError="showToastError"
        v-bind:showToastMessage="showToastMessage"/>
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration passReset three">
          <h4>{{ $t("password_reset.title2") }}</h4>
          <p>{{ $t("password_reset.text2") }}</p>
          <form action="#" class="custom-form">
            <div class="form-group" v-bind:class="{ 'not-empty': !isPasswordEmpty }">
              <input
                v-bind:type="passwordType"
                class="form-control"
                name="pass"
                id="pass"
                v-model="form.password"
                required
                @blur="formUtilsCheckPasswordSave()"
              />
              <label for="pass" class="animated-label">{{ $t("login.password") }}</label>
              <span
                class="icon passVisible"
                v-bind:class="{
                  warpit_icon_eye: isPasswordEyeSlashClass,
                  'warpit_icon_eye-slash': !isPasswordEyeSlashClass,
                }"
                v-on:click.prevent="formUtilsShowPassword()"
              ></span>
              <span class="line"></span>
            </div>
            <span
              class="errorSexTxt"
              v-if="errors.password"
              for="password"
            >{{ $t("error.invalid_password") }}</span>
            <div class="form-group" v-bind:class="{ 'not-empty': !isConfirmPasswordEmpty }">
              <input
                v-bind:type="passwordConfirmationType"
                class="form-control"
                name="passAg"
                id="passAg"
                v-model="form.passwordConfirmation"
                required
                @blur="formUtilsCheckPasswordConfirmation()"
              />
              <label for="passAg" class="animated-label">{{ $t("login.newpassword") }}</label>
              <span
                class="icon passVisible"
                v-bind:class="{
                  warpit_icon_eye: isConfirmationPasswordEyeSlashClass,
                  'warpit_icon_eye-slash': !isConfirmationPasswordEyeSlashClass,
                }"
                v-on:click.prevent="formUtilsShowConfirmationPassword()"
              ></span>
              <span class="line"></span>
            </div>
            <span
              class="errorSexTxt"
              v-if="errors.confirmPassword"
              for="password"
            >{{ $t("error.passwords_do_not_match") }}</span>
          </form>
          <div class="next flex">
            <a
              class="join smallFont hoverEffect"
              ref="joinButton1"
              v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton1')"
              v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton1')"
              v-on:click.prevent="onSubmit()"
              href="javascript:void(0);"
            >
              <label>{{ $t("login.save_and_login") }}</label>
              <span
                class="effect"
                ref="effectButton1"
                v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
              ></span>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import { formUtilsCheckEmail, formUtilsCheckPasswordSave, formUtilsMouseHoverEffect, formUtilsShowPassword, formUtilsShowConfirmationPassword, formUtilsCheckPasswordConfirmation } from '@/utils/form_utils.js';

import MasterHeader from './partials/MasterHeader';
export default {
  data() {
    return {
      isPasswordEyeSlashClass: true,
      isPasswordEmpty: true,
      passwordType: "password",

      isConfirmationPasswordEyeSlashClass: true,
      isConfirmPasswordEmpty: true,
      passwordConfirmationType: "password",

      showToastError: false,
      showToastMessage: "",

      tokenValid: null,
      form: {
        token: "",
        password: "",
        passwordConfirmation: "",
        recaptchaToken: ''
      },
      errors: {
        password: false,
        confirmPassword: false,
      },
      topX: 1,
      leftX: 1,
      notCompleted: true,
    };
  },
  components: {
    MasterHeader
  },
  mounted() {
    this.$initRecaptcha();

    this.form.token = this.$route.params.token;
    this.checkTokenValidation();
  },
  methods: {
    formUtilsShowPassword,
    formUtilsMouseHoverEffect,
    formUtilsShowConfirmationPassword,
    formUtilsCheckPasswordSave,
    formUtilsCheckPasswordConfirmation,

    async onSubmit() {
      /* CHECK FIELDS BEFORE SUBMIT */
      this.formUtilsCheckPasswordSave();
      if (this.errors.password === true) {
        return;
      }

      this.formUtilsCheckPasswordConfirmation();
      if (this.errors.confirmPassword === true) {
        return;
      }

      /* CHECK CAPTCHA */
      this.$checkRecaptcha().then((token) => {
        this.sendForm(token);
      }).catch((error) => {
        console.error("Error reCAPTCHA:", error);
      });
    },

    async sendForm(recaptchaToken) {
      this.form.recaptchaToken = recaptchaToken;

        await this.$http
          .post("api/v1/resetPassword", this.form)
          .then(() => {
            this.$router.push({
              name: "login",
              params: {},
              query:{
                activeTab: 'login',
              }
            });
            return;
          })
          .catch(() => {
            this.showToastMessage = this.$t("error.invalid_update");
            this.showToastError = true;
          });
    },

    checkTokenValidation() {
      this.$http
        .post("api/v1/validatePasswordResetToken", {
          token: this.form.token,
        })
        .then(() => {
          this.tokenValid = true;
        })
        .catch(() => {
          this.tokenValid = false;
          this.showToastMessage = this.$t("error.invalid_token");
          this.showToastError = true;
        });
    },

  },
};
</script>